module.exports = __webpack_public_path__ + "static/media/firewall_principle.4b3814d4.png";